module.exports = __webpack_public_path__ + "img/logo.ccbe21d1.png";